/* istanbul ignore file - need to fix flakey tests */
import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import { productInventoryEndpoints } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';
import type { PUTPartCategory } from './useSavePartsCategories';

interface PUTPartCategoriesBody {
  configurationPID: string;
  categories: PUTPartCategory[];
}

export interface UseCreatePartCategoriesVars extends PUTPartCategoriesBody {
  productPID: string;
  accountId: string;
  partCategoriesJobRunID: string;
}

export interface PUTPartsCategoriesResponse {
  version: string;
  url: string;
}

export const useCreatePartCategories = () => {
  const { getService } = useProductInventory();

  return useMutation<PUTPartsCategoriesResponse, Error, UseCreatePartCategoriesVars>({
    mutationFn: async ({ productPID, accountId, partCategoriesJobRunID, configurationPID, categories }) => {
      const productInventoryService = await getService();

      return (
        await productInventoryService.put(
          `${productInventoryEndpoints.products}/${productPID}${productInventoryEndpoints.partCategories}`,
          { configurationPID, categories },
          { params: { account: accountId, partCategoriesJobRunID } }
        )
      ).data.payload;
    },
  });
};
